// extracted by mini-css-extract-plugin
export default {"colorSelector":"n33jXSErygU3t16IlBGZ","title":"yX_DWi6Y61cq8X5dfVnP","checkIcon":"CSWnKJqOTSA_uCEyGp35","selector":"jGoMhDo0GvFB8avXR5XW"};